// extracted by mini-css-extract-plugin
export default {"heading":"rjiFy0dXpfYbBIMbB8wMT","map":"_5oBlXQiCrf6Q9yoHblY6IP","address":"_35QQ1kD0VgGUMqncQh3JJ7"};